import React from 'react'
import { Box } from '@chakra-ui/react'
import CancellationsTable from './components/CancellationsTable'

export default function CancellationsView() {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <CancellationsTable />
    </Box>
  )
}
